<!-- =========================================================================================
  File Name: data.vue
  Description: Lottery Data
========================================================================================== -->

<template>
  <div id="lottery-plan">

    <vx-card title="计划管理">
      <vs-table stripe :data="list" noDataText="暂无计划">
        <template slot="thead">
          <vs-th width="250">计划名称</vs-th>
          <vs-th width="300">彩票类型</vs-th>
          <vs-th width="300">默认玩法</vs-th>
          <vs-th width="400">默认下注内容</vs-th>
          <vs-th width="200">止盈 (%)</vs-th>
          <vs-th width="450">操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list" >
            <vs-td :data="item.name">
              <vs-input v-model="item.name" class="w-full" />
            </vs-td>
           <vs-td :data="item.lottery_type">
             <vs-select class="w-full" v-model="item.lottery_type">
               <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item, index) in lotteryTypes" />
             </vs-select>
           </vs-td>
           <vs-td :data="item.played_id">
             <vs-select class="w-full" v-model="item.played_id">
               <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item, index) in playedList" />
             </vs-select>
           </vs-td>
           <vs-td :data="item.content">
             <vs-input v-model="item.content" placeholder="多个请用,隔开" class="w-full" />
           </vs-td>
            <vs-td :data="item.target_win">
              <vs-input v-model="item.target_win" placeholder="0为不限制" type="number" class="w-full" />
            </vs-td>
            <vs-td>
              <vs-button color="primary" type="filled" size="small" @click="modify(index)" :data-index="index">{{item.id === -1 ? '添加' : '更改'}}</vs-button>
              <vs-button color="danger" type="filled" size="small" @click="del" :data-index="index" class="ml-2">删除</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div class="mt-4">
        <vs-button color="warning" type="filled" size="small" @click="add">添加计划</vs-button>
      </div>

      <vs-pagination class="mt-6" :total="totalPage" v-model="page" goto />
    </vx-card>
    
    <vs-prompt
      vs-title="编辑计划"
      vs-accept-text="确认"
      vs-cancel-text="取消"
      :vs-active.sync="dialog.visible"
      @vs-accept="addDo"
    >
      <div class="mb-4">
        <vs-table stripe :data="list" noDataText="暂无计划">
          <template slot="thead">
            <vs-th width="100">轮次</vs-th>
            <vs-th width="150">倍数</vs-th>
            <vs-th width="400">玩法</vs-th>
            <vs-th width="400">下注内容</vs-th>
            <vs-th width="150">中奖跳转</vs-th>
            <vs-th width="150">挂后跳转</vs-th>
            <vs-th width="200">操作</vs-th>
          </template>
        
          <template slot-scope="{data}">
            <vs-tr :key="index" v-for="(item, index) in dialog.data.list" >
              <vs-td :data="index">
                <div>{{ index + 1 }}</div>
              </vs-td>
             <vs-td :data="item.rate">
               <vs-input v-model="item.rate" class="w-full" />
             </vs-td>
             <vs-td :data="item.played_id">
               <vs-select class="w-full" v-model="item.played_id" placeholder="留空则使用默认玩法">
                 <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item, index) in playedList" />
               </vs-select>
             </vs-td>
             <vs-td :data="item.content">
               <vs-input v-model="item.content" placeholder="留空则使用默认下注内容" class="w-full" />
             </vs-td>
             <vs-td :data="item.success">
               <vs-input v-model="item.success" class="w-full" />
             </vs-td>
              <vs-td :data="item.failed">
                <vs-input v-model="item.failed" class="w-full" />
              </vs-td>
              <vs-td>
                <vs-button color="danger" type="filled" size="small" @click="dialog.data.list.splice(index, 1)">删除</vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="mt-4">
          <vs-button color="success" size="small" @click="dialog.data.list.push({})">添加</vs-button>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      totalPage: 1,
      list: [],
      lotteryTypes: [
        {
          value: 'ssc',
          label: '时时彩'
        }
      ],
      playedList: [
        {
          value: 325,
          label: '龙虎和_1球vs2球'
        },
        {
          value: 326,
          label: '龙虎和_1球vs3球'
        },
        {
          value: 327,
          label: '龙虎和_1球vs4球'
        },
        {
          value: 328,
          label: '龙虎和_1球vs5球'
        },
        {
          value: 329,
          label: '龙虎和_2球vs3球'
        },
        {
          value: 330,
          label: '龙虎和_2球vs4球'
        },
        {
          value: 331,
          label: '龙虎和_2球vs5球'
        },
        {
          value: 332,
          label: '龙虎和_3球vs4球'
        },
        {
          value: 333,
          label: '龙虎和_3球vs5球'
        },
        {
          value: 334,
          label: '龙虎和_4球vs5球'
        }
      ],
      dialog: {
        visible: false,
        data: {
          list: []
        }
      },
      shortname: '',
      number: '',
      multiAddShow: false,
      multiAddShortname: '',
      multiAddData: '',
      generateShow: '',
      generateIsShow: false,
      generateTypeList: ['一', '三', '五'],
      generateTypeIndex: 0,
      generateCount: 10
    }
  },
  methods: {
    modify (index) {
      const item = this.list[index]
      item.list = item.list || []
      this.dialog.visible = true
      this.dialog.data = JSON.parse(JSON.stringify(item))
    },
    load () {
      const postdata = {}
      postdata.authKey = localStorage.getItem('authKey')
      postdata.page = this.page
      this.$utils.post('lottery-planList', postdata).then(res => {
        this.list = res.list
        this.totalPage = Math.ceil(res.count / res.pagesize)
      })
    },
    del(e) {
      const index = e.currentTarget.dataset.index
      if (this.list[index].id === -1) {
        this.list.splice(index, 1)
        return
      }
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认删除这条计划吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          const postdata = {}
          postdata.authKey = localStorage.getItem('authKey')
          postdata.id = this.list[index].id
          this.$utils.post('lottery-deletePlan', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
            this.load()
          })
        }
      })
    },
    add() {
      this.list.push({ id: -1 })
    },
    addDo() {
      const postdata = JSON.parse(JSON.stringify(this.dialog.data))
      postdata.authKey = localStorage.getItem('authKey')
      postdata.list = JSON.stringify(postdata.list)
      this.$utils.post('lottery-modifyPlan', postdata).then(res => {
        this.$vs.dialog({
          title: '提示',
          text: res,
          acceptText: '确认'
        })
        this.load()
      })
    },
    search() {
      this.page = 1
      this.load()
    }
  },
  watch: {
    page(newValue) {
      this.page = newValue
      this.load()
    }
  },
  mounted () {
    this.load()
  }
}
</script>

<style lang="scss">
  .vs-dialog {
    max-width: 800px !important;
  }
</style>
